export default "__VITE_PUBLIC_ASSET__27192843__"